import HeaderLabel from './HeaderLabel';

export default HeaderLabel;
